import { faDesktop, faLocationDot } from '@fortawesome/pro-light-svg-icons';
import { Professional, ProfessionalSchedule } from '@medprev-web-app/api-graphql-client';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Icon } from '@/components/ui/icon.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { formatToTitleCase } from '@/utils/formatters/format-to-title-case';
import { transformInPersonSchedules } from '@/utils/professional/extract-professional-location';

interface ProfessionalServiceLocationsProps {
  professional: Professional;
  telehealthData: ProfessionalSchedule[];
  inPersonData: ProfessionalSchedule[];
  dataTestId?: string;
}

export function ProfessionalServiceLocations({
  inPersonData,
  telehealthData: telehealthSchedules,
  dataTestId,
}: ProfessionalServiceLocationsProps) {
  const inPersonLocations = transformInPersonSchedules(inPersonData);

  const totalInPersonLocations = Object.values(inPersonLocations).reduce((acc, locArray) => acc + locArray.length, 0);

  const entityTile
    = totalInPersonLocations > 1 || (telehealthSchedules.length && totalInPersonLocations > 0)
      ? 'Locais de atendimento'
      : 'Local de atendimento';

  return (
    <div data-testid={dataTestId}>
      <Typography variant={TypographyVariant.BODY_STRONG} as="h2" className="!text-lg sm:!text-lg">
        {entityTile}
      </Typography>
      {!!telehealthSchedules.length && (
        <div className="flex gap-2 mt-5" data-testid={DataTestIdEnum.PROFESSIONAL_SERVICE_LOCATIONS_TELEHEALTH_SECTION}>
          <Icon icon={faDesktop} className="text-gray-500 w-6 h-6" />
          <div className="flex flex-col">
            <span className="text-gray-700 font-bold text-base">Teleconsulta</span>
            <span className="text-gray-700 text-base">Atendimento por chamada de vídeo</span>
          </div>
        </div>
      )}
      {totalInPersonLocations > 0 && (
        <div className="mt-3" data-testid={DataTestIdEnum.PROFESSIONAL_SERVICE_LOCATIONS_IN_PERSON_SECTION}>
          {Object.entries(inPersonLocations).map(([key, value]) => (
            <div key={key} className="mt-3" data-testid={`in-person-location-${key}`}>
              <div className="flex gap-2">
                <Icon icon={faLocationDot} className="text-gray-500 w-6 h-6" />
                <div className="flex flex-col">
                  <span className="text-gray-700 font-bold text-base">{key}</span>
                  {value.map((address) => (
                    <div key={address.socialName} className="mt-1 pl-0">
                      <span className="text-green-500 font-semibold text-base">{formatToTitleCase(address.socialName)}</span>
                      <p className="text-gray-700 text-base">{formatToTitleCase(address.neighborhood)}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      <hr className="mt-7" />
    </div>
  );
}
